import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

import { Time } from '../types';

dayjs.extend(duration);

/**
 * Resolves an ISO 8601 Duration or timestamp to a number.
 * Source: https://docs.digi.com/resources/documentation/digidocs/90001488-13/reference/r_iso_8601_duration_format.htm
 *
 *
 * @param v - The duration or timestamp to resolve.
 * @returns The resolved number.
 */
export function resolveDurationOrTimestamp(v: string | number): number {
    if (typeof v === 'number' || !Number.isNaN(Number(v))) {
        return Number(v);
    }
    // We are using the dayjs duration plugin to parse the duration and then we are
    // subtracting the duration from the current time.
    // Source: https://day.js.org/docs/en/plugin/duration
    const duration = dayjs.duration(v).asMilliseconds();

    // If the duration is not a number, throw an error.
    if (Number.isNaN(duration)) {
        throw new Error('Invalid ISO 8601 duration value');
    }

    return Date.now() - duration;
}

/**
 * Resolves the time properties from a Time object.
 */
export function resolveTimeProps(time: Time): Time {
    return {
        from: resolveDurationOrTimestamp(time.from),
        to: time.to ?? Date.now()
    };
}
